import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MaterialModule } from '@core/modules';

import { RegistrationRoutingModule } from './registration.routing.module';
import { RegistrationComponent } from './registration/registration.component';
import { LogoComponent } from '@shared/components';
import { SetImagePathDirective } from "@shared/directives";

@NgModule({
  declarations: [RegistrationComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    RegistrationRoutingModule,
    MatStepperModule,
    MatProgressBarModule,
    LogoComponent,
    SetImagePathDirective
],
})
export class RegistrationModule {}
